import KeyDecision from "../model/KeyDecision";

export default class KeyDecisionEvent {
    /**
     * @constructor
     * @param {string} type 
     * @param {KeyDecision} keyDecision 
     */
    constructor(type, keyDecision) {
        this.type = type;
        this.keyDecision = keyDecision;
    }
}

KeyDecisionEvent.KEY_DECISION_AVAILABLE = "KeyDecisionEvent.KEY_DECISION_AVAILABLE";
KeyDecisionEvent.KEY_DECISION_UNAVAILABLE = "KeyDecisionEvent.KEY_DECISION_UNAVAILABLE";
KeyDecisionEvent.KEY_DECISION_COMPLETED = "KeyDecisionEvent.KEY_DECISION_COMPLETED";